import { getCurrencyString } from '~/utils/currencyUtils';

const getBudgetOptions = (currency) => {
  const budgetOptions = [
    {
      label: `under ${getCurrencyString(currency, 1000)}`,
      value: `under ${getCurrencyString(currency, 1000)}`,
    },
    {
      label: `${getCurrencyString(currency, 1000)} -  ${getCurrencyString(currency, 1999)}`,
      value: `${getCurrencyString(currency, 1000)} -  ${getCurrencyString(currency, 1999)}`,
    },
    {
      label: `${getCurrencyString(currency, 2000)} -  ${getCurrencyString(currency, 3999)}`,
      value: `${getCurrencyString(currency, 2000)} -  ${getCurrencyString(currency, 3999)}`,
    },
    {
      label: `${getCurrencyString(currency, 4000)} -  ${getCurrencyString(currency, 5999)}`,
      value: `${getCurrencyString(currency, 4000)} -  ${getCurrencyString(currency, 5999)}`,
    },
    {
      label: `${getCurrencyString(currency, 6000)} -  ${getCurrencyString(currency, 9999)}`,
      value: `${getCurrencyString(currency, 6000)} -  ${getCurrencyString(currency, 9999)}`,
    },
    {
      label: `${getCurrencyString(currency, 10000)} -  ${getCurrencyString(currency, 19999)}`,
      value: `${getCurrencyString(currency, 10000)} -  ${getCurrencyString(currency, 19999)}`,
    },
    {
      label: `${getCurrencyString(currency, 20000)} -  ${getCurrencyString(currency, 39999)}`,
      value: `${getCurrencyString(currency, 20000)} -  ${getCurrencyString(currency, 39999)}`,
    },
    {
      label: `${getCurrencyString(currency, 40000)}+`,
      value: `${getCurrencyString(currency, 40000)}+`,
    },
  ];

  return budgetOptions;
};

export { getBudgetOptions };
